import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import { FORM } from 'organisms/SearchStore/AU/Config/searchStore.config';
import { useDispatch, useSelector } from 'react-redux';
import { SearchStoreModule } from 'organisms/SearchStore/AU/Container/SearchStoreContainer';
import { findkfcSeoObj, getFindKFCContentData } from 'organisms/SearchStore/AU/SearchStoreUtilities/SearchStoreUtils';
import { resetStores } from '@kfc-global/react-shared/redux/Actions/StoresAction';
import { getContent, getFindAKFCContent } from 'common/utilities/content';
import { StructureData } from 'organisms/StructureDataComponent';
import { setAnalyticsData } from 'organisms/StartOrderComponent/StartOrderUtilities/startOderUtils';
import START_ORDER_CONSTANTS from 'organisms/StartOrderComponent/Constants/startOrderConstants';
import { UserOrderContext } from 'context/context';
import { Row } from 'reactstrap';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import ImageComponent from 'atoms/Image/index';
import { DISPOSITION_KEYS, LOCAL_STORAGE_KEYS, FIND_KFC, RESIZE } from 'common/constants/SharedConstants';
import { isEmptyEvery, isMobileDeviceOnly } from 'common/utilities/utils';
import { setLocalisationFinishAnalyticsData } from 'common/utilities/analyticsUtils';
const { DISPOSITION_METHOD, SET_FIND_A_KFC_VIEW, SEARCH_ORDER_DATA } = START_ORDER_CONSTANTS;

export const FindAKFCContainer = props => {
  const { userOrderState, userOrderStateDispatch } = useContext(UserOrderContext) || {};
  const dispatch = useDispatch();
  const [isMobile, setMobileHeader] = useState(isMobileDeviceOnly(window.innerWidth));
  const userParams = useSelector(data => data?.appStateReducer?.userStatus);
  const [seoData, setSeoData] = useState({ page: '', seoObj: {} });
  const history = useHistory();
  const [segmentedFindAKFCData, setSegmentedFindAKFCData] = useState({});
  const allContentData = useSelector(data => {
    return {
      homePageContent: get(data, 'contentReducer.response', null),
      findAKFCContent: get(data, 'contentReducer.findAKFCContentData', null),
    };
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    dispatch(resetStores());
    return () => {
      dispatch(resetStores());
    };
  }, [userOrderState.findAKFC, dispatch]);

  const windowResized = () => {
    const isMobileView = isMobileDeviceOnly(window.innerWidth);
    setMobileHeader(isMobileView);
  };
  useEffect(() => {
    window.addEventListener(RESIZE, windowResized);
  }, [isMobile]);

  useEffect(() => {
    userOrderStateDispatch({
      type: SET_FIND_A_KFC_VIEW,
      value: { findAKFC: true },
    });
  }, [userOrderStateDispatch]);

  useEffect(() => {
    if (userOrderState.findAKFC) {
      const timer = setInterval(() => {
        if (window.google) {
          clearInterval(timer);
          setFindKFCView();
        }
      }, 100);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userOrderState.findAKFC]);

  useEffect(() => {
    dispatch(getContent(userParams));
  }, [dispatch, userParams, userOrderState.cmsInitialized]);

  useEffect(() => {
    dispatch(getFindAKFCContent());
  }, [dispatch]);

  useEffect(() => {
    if (!isEmpty(allContentData.findAKFCContent) && !isEmpty(allContentData.homePageContent)) {
      const result = findkfcSeoObj(allContentData?.homePageContent?.seoStructureData?.seo) ?? {};
      setSeoData({ page: FIND_KFC, seoObj: result });
      setSegmentedFindAKFCData(getFindKFCContentData(allContentData.findAKFCContent?.findAKFCResp?.items?.[0]?.fields));
    }
  }, [allContentData?.homePageContent, allContentData.findAKFCContent, history]);

  const setFindKFCView = () => {
    setAnalyticsData();
    const dispositionNew = isEmptyEvery(userOrderState.dispositionNew)
      ? JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.DISPOSITION_NEW))
      : userOrderState.dispositionNew;
    const serviceType = dispositionNew?.type || DISPOSITION_KEYS.PICKUP;
    userOrderStateDispatch({
      type: DISPOSITION_METHOD,
      value: { dispositionType: serviceType },
    });
    userOrderStateDispatch({
      type: SEARCH_ORDER_DATA,
      value: { showSearchStore: true, configSearchScreen: FORM },
    });
    localStorage.setItem(LOCAL_STORAGE_KEYS.CONFIG_SEARCH_SCREEN, FORM);
  };

  return (
    <React.Fragment>
      <>
        <StructureData {...seoData} />
        <div className='findkfc-container' data-testid='findkfc-container-test'>
          <div className='findkfc-container-content'>
            <div className='findkfc-header-container'>
              <Row className='findkfc-stripes-section'>
                <ImageComponent
                  srcFile={isMobile ? IMAGE_PATH.StripsIconMobile : IMAGE_PATH.StripesIcon}
                  className='stripes-img'
                />
              </Row>
              <h2 className='findkfc-header-title'>{segmentedFindAKFCData.headLine}</h2>
              <span className='findnearkfc-text'>{segmentedFindAKFCData.subHeadLine}</span>
            </div>
            <div className='findkfc-search-module' data-testid='findkfc-search-module-test'>
              {userOrderState.findAKFC && userOrderState?.searchStoreData?.showSearchStore && (
                <SearchStoreModule
                  finAKFCContentData={segmentedFindAKFCData}
                  onStoreSelectFinish={setLocalisationFinishAnalyticsData}
                  isMobile={isMobile}
                />
              )}
            </div>
          </div>
        </div>
      </>
    </React.Fragment>
  );
};

export default FindAKFCContainer;
